module.exports = __webpack_public_path__ + "static/the-art-of-war-2d7c8566879e988fe816247238f2461c.jpg";